
import React, { useContext } from 'react';
import { CurrencyUtils } from '../../common/CurrencyUtils';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { QueryByType } from '../../domain/constants/QueryByType';
import { ModalMovActions } from '../../presentation/redux/actions/ModalMovActions';
import { ModalMovState } from '../../presentation/redux/states/ModalMovState';
import authContext from '../../context/auth/authContext';
import './style.css';
import { help } from '../../domain/utils/help';


export function ResumenDia() {

  /* const resume = useSelector((state: RootState) => state.balanceState.resumeSellPerDay) */
  const resume = useSelector((s: RootState) => s.balanceState.balance);
  const uiState = useSelector((s: RootState) => s.uiState);
  const dispatch = useDispatch();


  const AuthContext = useContext(authContext);
  const { token } = AuthContext;



  const infoCobroServicio = `Suma de los cobros determinados por tu distribuidor en cada transacción de pago de recaudos que realices.<br></br> Normalmente es un cobro menor a S/ 10 por transacción`;
  const infoAjusteComisionCompra = `
  <p>Al hacer una compra, se te abona un saldo por adelantado. <strong>Por ejemplo</strong>, al abonar S/ 1000 recibes S/ 1000 más el porcentaje de comisión que tengas asignado, si tienes un 5% de comisión, recibirás S/ 1050, ya que todo está pensado en consumir en recargas virtuales.</p>

  <p>Cuando realizas un pago de recaudo, consumes ese saldo que ya tenía una comisión abonada. Por lo tanto, se debe realizar un ajuste del monto del pago de recaudo más el cobro por pago de recaudo por el porcentaje de comisión que ya se abonó.</p>

  <p><strong>Ejemplo:</strong></p>

  <ul style="text-align: left; margin-left: 20px;">
    <li><strong>Comisión asignada del 5%</strong></li>
    <li><strong>Transacción recaudo por S/ 500</strong></li>
  </ul>

  <strong>Descuentos:</strong>
  <ul style="text-align: left; margin-left: 20px;">
    <li><strong>S/ 500</strong> monto del pago de recaudo</li>
    <li><strong>S/ 4</strong> cobro por pago de recaudo</li>
    <li><strong>S/ 25</strong> de ajuste de comisión del monto</li>
    <li><strong>S/ 0.20</strong> de ajuste de comisión del cobro por pago de recaudo</li>
  </ul>
  <strong>Descuento total: S/ 529.20</strong>
`;

  const handleOpen = (mt: any) => {
    switch (mt) {
      case 'day':
        dispatch(
          ModalMovActions.open(
            new ModalMovState({
              title: "Resumen de Movimientos",
              date: new Date(),
              isResume: true,
              isCustom: false,
              queryType: QueryByType.DATE,
              token: token
            })
          ));
        break;

      case 'month':
        dispatch(
          ModalMovActions.open(
            new ModalMovState({
              title: "Resumen de Movimientos",
              date: new Date(),
              isResume: true,
              isCustom: false,
              queryType: QueryByType.MONTH,
              token: token
            })
          ));
        break

      case 'last_month':
        const date = new Date();
        date.setMonth(date.getMonth() - 1);
        dispatch(
          ModalMovActions.open(

            new ModalMovState({
              title: "Resumen de Movimientos",
              date: date,
              isResume: true,
              isCustom: false,
              queryType: QueryByType.MONTH,
              token: token
            })
          ));
        break

      default:
        dispatch(
          ModalMovActions.open(
            new ModalMovState({
              title: "Resumen de Movimientos",
              date: new Date(),
              isResume: true,
              isCustom: true,
              queryType: QueryByType.MONTH,
              token: token
            })
          ));
        break;
    }
  }

  return resume ?
    (
      <div className="row cardNeu mx-1 my-4 col-12">
        <div className="col">
          <div className="row">
            <div className="col">
              <h4 className="lvender text-center pt-3 pb-2 ">Resumen del Día</h4>
            </div>
          </div>
          <div className="row">
            <div className="col ml-4 mr-4">
              <table className="table">
                <thead>
                  <tr className="d-none d-md-table-row">
                    <th style={{ width: '1%' }} >
                      <h1 className="lventa text-left">Movimientos</h1>
                    </th>
                    <th style={{ width: '1%' }} className="lventa">
                      <h1 className="lventa px-3 text-right">Monto</h1>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* <!-- Filas --> */}
                  <tr>
                    {/* <!-- Columnas --> */}
                    <td className="tdResumen text-left">
                      Saldo Inicial
                    </td>
                    <td className="text-right">
                      {
                        uiState.isShowBalance ?
                          resume.init_balance :
                          '***'
                      }
                    </td>
                  </tr>
                  <tr>
                    {/* <!-- Columnas --> */}
                    <td className="text-left">
                      <i className="fas fa-plus mr-1"></i> Compras
                    </td>
                    <td className="text-right">
                      {
                        uiState.isShowBalance ?
                          (resume.movs_balance || CurrencyUtils.moneyFormat(0)) :
                          '***'
                      }
                    </td>
                  </tr>
                  <tr>
                    {/* <!-- Columnas --> */}
                    <td className="text-left">
                      <i className="fas fa-minus mr-1"></i> Ventas
                    </td>
                    <td className="text-right">
                      {
                        uiState.isShowBalance ?
                          (resume.ops_balance || CurrencyUtils.moneyFormat(0)) :
                          '***'
                      }
                    </td>
                  </tr>
                  <tr id='cobro-servicio'>
                    {/* <!-- Columnas --> */}
                    <td className="text-left d-flex align-items-center position-relative">
                      <button className='btn position-absolute btn-position-custom' onClick={(e) => help(e, 'Cobro recaudos', infoCobroServicio)}><i className="far fa-question-circle"></i>
                        {/* <span className='info'>Cobro recaudos</span> */}
                      </button>
                      <i className="fas fa-minus mr-1"></i> Cobro recaudos
                    </td>
                    <td className="text-right">
                      {
                        uiState.isShowBalance ?
                          (resume.cobro_servicio || CurrencyUtils.moneyFormat(0)) :
                          '***'
                      }
                    </td>
                  </tr>
                  <tr id='ajuste-comision-compra' >
                    {/* <!-- Columnas --> */}
                    <td className="text-left d-flex align-items-center position-relative">
                      <button className='btn align-content-center position-absolute btn-position-custom' onClick={(e) => help(e, 'Ajuste Comisión Compra', infoAjusteComisionCompra)}><i className="far fa-question-circle"></i>
                        {/* <span className='info'>Ajuste Comisión Compra</span> */}
                      </button>
                      <i className="fas fa-minus mr-1"></i>Ajuste Comisión Compra
                    </td>
                    <td className="text-right align-content-center">
                      {
                        uiState.isShowBalance ?
                          (resume.ajuste_comision_compra || CurrencyUtils.moneyFormat(0)) :
                          '***'
                      }
                    </td>
                  </tr>
                  <tr>
                    {/* <!-- Columnas --> */}
                    <td className="text-left">
                      <i className="fas fa-plus mr-1"></i> Comisiones
                    </td>
                    <td className="text-right">
                      {
                        uiState.isShowBalance ?
                          (resume.profits || CurrencyUtils.moneyFormat(0)) :
                          '***'
                      }
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td className="text-left">
                      <i className="fas fa-grip-lines mr-1"></i> Total
                    </td>
                    <td className="text-right">
                      {
                        uiState.isShowBalance ?
                          resume.total :
                          '***'
                      }
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div className="button-grid">
            <button type="button" onClick={() => handleOpen('day')}
              className="btn btnPrimary btn-transparent">Reporte del día
            </button>
            <button type="button" onClick={() => handleOpen('month')}
              className="btn btnPrimary btn-transparent">Mes actual
            </button>
            <button type="button" onClick={() => handleOpen('last_month')}
              className="btn btnPrimary btn-transparent">Mes anterior
            </button>
            <button type="button" onClick={() => handleOpen('custom')}
              className="btn btnPrimary btn-transparent">Personalizado
            </button>
          </div>
          <div className="row">
            <div className="col text-center mb-3">
              <button className="btn-cuentas"
                onClick={() => {
                  dispatch(UIActions.openDepositAccounts());
                }}>
                <label>Cuentas para Depósito </label>
              </button>
            </div>
          </div>
        </div>
      </div>) : <></>;
}
